var _style, _g, _g2, _g3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDarthVaderLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0dvl{fill:#791712;}\r\n\t.st1dvl{fill:#3A3A3A;}\r\n\t.st2dvl{fill:#141414;}\r\n\t.st3dvl{fill:#424242;}\r\n\t.st4dvl{fill:#2B2B2B;}\r\n\t.st5dvl{fill:#E8E6E6;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lag_1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0dvl",
    cx: 150,
    cy: 150.3,
    r: 150
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1dvl",
    d: "M258.9,229.6c-72.6,0-145.2,0-217.9,0c17.9-41.1,35.8-82.2,53.8-123.3c37.3-1.3,74.6-2.6,112-3.9 C224.2,144.8,241.6,187.2,258.9,229.6z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2dvl",
    d: "M227.1,124.6c0.4-3.6,4.2-39-23-64c-22-20.3-48.9-19.4-54-19.1c-5.2-0.3-32-1.2-54,19.1 c-27.2,25-23.4,60.4-23,64c-13.2,35-26.4,70-39.6,105c4.3,0,8.7,0,13,0c15.9-35,31.7-70,47.6-105c3.5-2.6,12.8-8.6,26.2-9.2 c15.6-0.6,26.6,6.8,29.9,9.2c3.3-2.4,14.3-9.8,29.9-9.2c13.4,0.5,22.7,6.6,26.2,9.2c15.9,35,31.7,70,47.6,105c4.3,0,8.7,0,13,0 C253.5,194.6,240.3,159.6,227.1,124.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2dvl",
    d: "M142,136.6c-2.3,17.4-15.1,29.4-28,29.4c-10.9,0-18.4-8.4-20-10.3c-0.9-10.4,3.5-20.4,11.6-25.6 C116.4,123.1,132.2,125.4,142,136.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2dvl",
    d: "M158,136.6c2.3,17.4,15.1,29.4,28,29.4c10.9,0,18.4-8.4,20-10.3c0.9-10.4-3.5-20.4-11.6-25.6 C183.6,123.1,167.8,125.4,158,136.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3dvl",
    d: "M189.4,205.5c-26.2,0-52.5,0-78.7,0c-4.5-10.8-8.9-21.5-13.4-32.3c35.7,0,71.5,0,107.2,0 C199.4,183.9,194.4,194.7,189.4,205.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2dvl",
    d: "M194.5,218.3c3.3-14.9,6.6-29.8,9.9-44.7c-7.1,10.1-14.3,20.1-21.4,30.2c-7.1-7.9-14.1-15.7-21.2-23.6 c0.6-5.9-5.3-10.7-11.6-10.4c-6,0.2-11.2,4.9-10.6,10.4c-7,8-14,16-21,24c-7.1-10.1-14.1-20.3-21.2-30.4c3,14.9,5.9,29.7,8.9,44.6 C135.7,218.3,165.1,218.3,194.5,218.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4dvl",
    points: "109.9,229.6 191.9,229.6 150.9,176  "
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "st5dvl",
    cx: 150.9,
    cy: 182.7,
    rx: 6.7,
    ry: 9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2dvl",
    cx: 191.9,
    cy: 222.2,
    rx: 9.2,
    ry: 7.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2dvl",
    cx: 109.9,
    cy: 222.2,
    rx: 9.2,
    ry: 7.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 107.3,
    y: 223,
    className: "st2dvl",
    width: 85.4,
    height: 6.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 185.1,
    className: "st2dvl",
    width: 27.7,
    height: 6.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.3,
    y: 207.7,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 342.2531 79.9471)",
    className: "st2dvl",
    width: 27.7,
    height: 6.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.1,
    y: 207.7,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 383.0651 39.1351)",
    className: "st2dvl",
    width: 27.7,
    height: 6.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.7,
    y: 205.5,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 359.7916 57.9849)",
    className: "st2dvl",
    width: 36.5,
    height: 6.9
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarthVaderLogo);
export default __webpack_public_path__ + "static/media/darth-vader-logo.e1cc8084.svg";
export { ForwardRef as ReactComponent };